import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

interface DialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  type: "success" | "error" | "input";
  list?: string[];
  yesButton?: {
    label: string; // Custom label for the "Yes" button
    onClick: () => void; // Action for the "Yes" button
  };
  noButton?: {
    label: string; // Custom label for the "No" button
    onClick: () => void; // Action for the "No" button
  };
}

const SuccessErrorDialog: React.FC<DialogProps> = ({
  open,
  onClose,
  title,
  message,
  type,
  list,
  yesButton,
  noButton,
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <Dialog
      open={open}
      fullWidth={true}
      disableEscapeKeyDown={false}
      hideBackdrop={true}
      onBackdropClick={(e) => e.stopPropagation()}
    >
      <DialogTitle
        style={{
          color:
            type === "input" ? "#E8772C" : type === "success" ? "green" : "red",
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <p dangerouslySetInnerHTML={{ __html: message }} />
      </DialogContent>
      <DialogActions>
        {type === "input" && yesButton && (
          <Button
            onClick={yesButton.onClick}
            color="primary"
            style={{
              backgroundColor: "#E8772C",
              color: "white",
            }}
          >
            {yesButton.label}
          </Button>
        )}
        {/* No Button */}
        {type === "input" && noButton && (
          <Button
            onClick={noButton.onClick}
            color="secondary"
            style={{
              backgroundColor: "gray",
              color: "white",
            }}
          >
            {noButton.label}
          </Button>
        )}
        {/* OK Button */}
        {type !== "input" && (
          <Button
            onClick={onClose}
            color="primary"
            style={{
              backgroundColor: type === "success" ? "#E8772C" : "red",
              color: "white",
            }}
          >
            OK
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default SuccessErrorDialog;